import { ApplicationRight } from "../../share/RightList"
import _ from 'lodash';
import { AdsSettingsSeletedSvg, AdsSettingsSvg, EducationActiveSvg, EducationSvg, MagazineActiveSvg, MagazineSvg, NewsActiveSvg, NewsSvg, PaymentActiveSvg, PaymentSvg, ProductManagementSeletedSvg, ProductManagementSvg, ProductPurchaseSeletedSvg, ProductPurchaseSvg, StaffActiveSvg, StaffSvg, UserActiveSvg, UserSvg, FashionSVG, FashionActiveSVG, BannerManagementSvg, BannerManagementSvgActive, EventSvg, EventActiveSvg } from '../../assets/images/HeaderSvg';
import { RiCouponLine } from "react-icons/ri";

export const menus = (user) => {

  let menusNew = [
    {
      title: 'User Management',
      pathname: "/member",
      isGroup: false,
      icon: null,
      iconActive: null,
      accessingRights: [
        ApplicationRight.Member_Access,
      ],
      key: 'user-management',
      submenu: [
        {
          title: 'User Management',
          pathname: "/member",
          icon: <UserSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <UserActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Member_Access,
          ],
          key: 'user-management-item',
          submenu: null
        },
      ]
    },
    {
      title: 'Staff Management',
      pathname: "/staff/search",
      isGroup: false,
      icon: null,
      iconActive: null,
      accessingRights: [
        ApplicationRight.Staff_Management_Access,
        ApplicationRight.System_Setting_Access,
      ],
      key: 'staff-management',
      submenu: [
        {
          title: 'Staff Management',
          pathname: "/staff/search",
          icon: <StaffSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <StaffActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Staff_Management_Access,
          ],
          key: 'staff-management-item',
          submenu: null
        },
      ]
    },
    {
      title: 'Event Management',
      pathname: "/events",
      isGroup: false,
      icon: null,
      iconActive: null,
      accessingRights: [
        ApplicationRight.Event_Management_Access,
      ],
      key: 'event-management',
      submenu: [
        {
          title: 'Event Management',
          pathname: "/events",
          icon: <EventSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <EventActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Event_Management_Access,
          ],
          key: 'event-management-item',
          submenu: null
        },
      ]
    },
    {
      title: 'Order Management',
      pathname: "/payment",
      isGroup: true,
      icon: null,
      iconActive: null,
      accessingRights: [
        ApplicationRight.Payment_Access,
        ApplicationRight.Course_Purchase_Access,
        ApplicationRight.Product_Purchase_Access,
      ],
      key: 'order-management',
      submenu: [
        {
          title: 'Payment Management',
          pathname: "/payment",
          icon: <PaymentSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <PaymentActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Payment_Access,
          ],
          key: 'payment-management-item',
          submenu: null
        },
        {
          title: 'Course Purchase',
          pathname: "/course-purchase",
          icon: <EducationSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <EducationActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Course_Purchase_Access,
          ],
          key: 'course-purchase-item',
          submenu: null
        },
        {
          title: 'Product Purchase',
          pathname: "/product-purchase",
          icon: <ProductPurchaseSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <ProductPurchaseSeletedSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Product_Purchase_Access,
          ],
          key: 'product-purchase-item',
          submenu: null
        },
      ]
    },
    {
      title: 'Content Management',
      pathname: "/magazine",
      isGroup: true,
      icon: null,
      iconActive: null,
      accessingRights: [
        ApplicationRight.Magazine_Access,
        ApplicationRight.News_Posts_Access,
        ApplicationRight.Education_Management_Access,
        ApplicationRight.Product_Management_Access,
        ApplicationRight.Banner_Management_Access,
        ApplicationRight.Technology_Display_Access,
        ApplicationRight.Product_Knowledge_Access,
        ApplicationRight.Featured_Works_Access,
        ApplicationRight.Featured_Works_Sub_Access,
      ],
      key: 'content-management',
      submenu: [
        {
          title: 'Magazine Management',
          pathname: "/magazine",
          icon: <MagazineSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <MagazineActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Magazine_Access,
          ],
          key: 'magazine-management-item',
          submenu: null
        },
        {
          title: 'New Management',
          pathname: "/news-posts",
          icon: <NewsSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <NewsActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.News_Posts_Access,
          ],
          key: 'news-management-item',
          submenu: null
        },
        {
          title: 'Education Management',
          pathname: "/education-course",
          icon: <EducationSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <EducationActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Education_Management_Access,
          ],
          key: 'education-management-item',
          submenu: null
        },
        {
          title: 'Product Management',
          pathname: "/product",
          icon: <ProductManagementSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <ProductManagementSeletedSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Product_Management_Access,
          ],
          key: 'product-management-item',
          submenu: null
        },
        {
          title: 'Product Knowledge',
          pathname: "/products-knowledge",
          icon: <ProductManagementSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <ProductManagementSeletedSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Product_Knowledge_Access,
          ],
          key: 'product-knowledge-item',
          submenu: null
        },
        {
          title: 'Banner Management',
          pathname: "/banner",
          icon: <BannerManagementSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <BannerManagementSvgActive color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Banner_Management_Access,
          ],
          key: 'banner-management-item',
          submenu: null
        },
        {
          title: 'Technology Display',
          pathname: "/technical-posts",
          icon: <EducationSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <EducationActiveSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Technology_Display_Access,
          ],
          key: 'technology-display-item',
          submenu: null
        },
        {
          title: 'Featured Works',
          pathname: "/fashion",
          icon: <FashionSVG color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <FashionActiveSVG color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Featured_Works_Access,
          ],
          key: 'featured-works-item',
          submenu: null
        },
        {
          title: `Men's / Women's / Avant-Garde Creativity`,
          pathname: "/avant-garde",
          icon: <FashionSVG color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <FashionActiveSVG color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Featured_Works_Sub_Access,
          ],
          key: 'avant-garde-item',
          submenu: null
        },
      ]
    },
    {
      title: 'Promotion Management',
      pathname: "/ads-setting",
      isGroup: true,
      icon: null,
      iconActive: null,
      accessingRights: [
        ApplicationRight.Ads_Settings_Access,
        ApplicationRight.Coupon_Management_Access,
      ],
      key: 'promotion-management',
      submenu: [
        {
          title: 'Ads Settings',
          pathname: "/ads-setting",
          icon: <AdsSettingsSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          iconActive: <AdsSettingsSeletedSvg color="white" sx={{ color: 'white', width: `16px`, fontSize: "2rem" }} />,
          accessingRights: [
            ApplicationRight.Ads_Settings_Access,
          ],
          key: 'ads-settings-item',
          submenu: null
        },
        {
          title: 'Coupon Management',
          pathname: "/coupon",
          icon: <RiCouponLine style={{ color: '#636E88', width: `19px`, height: "19px", opacity: 0.6 }} />,
          iconActive: <RiCouponLine style={{ color: '#E50A47', width: `19px`, height: "19px" }} />,
          accessingRights: [
            ApplicationRight.Coupon_Management_Access,
          ],
          key: 'coupon-management-item',
          submenu: null
        },
      ]
    },
  ]

  const NavItem = (accessingRights) => {
    const hasRight = accessingRights && accessingRights.length ? !!_.intersection(user.rightList, accessingRights).length : true;
    return hasRight ? hasRight : false
  };

  const SiderNavSection = (accessingRights) => {
    const hasRight = accessingRights && accessingRights.length ? !!_.intersection(user.rightList, accessingRights).length : true;
    return hasRight ? hasRight : false
  };

  let menusN = []
  menusNew.forEach(it => {
    if (SiderNavSection(it.accessingRights)) {
      let itNew = { ...it }
      let submenu = []
      it.submenu && it.submenu.forEach(its => {
        if (NavItem(its.accessingRights)) {
          submenu.push(its)
        }
      });
      if (itNew.submenu) {
        if (submenu.length > 0) {
          itNew.pathname = submenu[0] && submenu[0].pathname
          itNew.submenu = [...submenu]
          menusN.push({ ...itNew })
        }
      } else {
        menusN.push({ ...itNew })
      }
    }
  });

  return menusN
}